import React, { createContext } from 'react'
import { useQuery } from '@apollo/client'
import useMe from 'src/graphql/hooks/useMe'
import { myUnreadMessageCount as myUnreadMessageCountGql }
   from 'src/graphql/queries/getMyUnreadMessageCount.gql'
import PropTypes from 'prop-types'

export const MyNotificationCountContext = createContext()

const MyNotificationCountProvider = ({ children }) => {
   const { me, isLoggedIn } = useMe()
   const { data, refetch } = useQuery(myUnreadMessageCountGql, {
      errorPolicy: 'ignore',
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      // Poll every 30 seconds
      pollInterval: process.env.NODE_ENV !== 'test'
         ? 30000
         : undefined,
      skip: !isLoggedIn
   })

   // Notification count is total of num invitations and unread messages
   const notificationCount = (me?.invitations?.length ?? 0) +
      (data?.myUnreadMessageCount ?? 0)

   let notificationCountResult = null

   if (notificationCount > 0) {
      notificationCountResult = notificationCount.toString()
   }

   if (notificationCount > 99) {
      notificationCountResult = '99+'
   }

   const contextValue = {
      refetch,
      notificationCount: notificationCountResult
   }

   return (
      <MyNotificationCountContext.Provider value={contextValue}>
         {children}
      </MyNotificationCountContext.Provider>
   )
}

MyNotificationCountProvider.propTypes = {
   children: PropTypes.node.isRequired
}

export { MyNotificationCountProvider }
